import React from 'react';
import {connect} from 'react-redux';
import {Typography} from '@mui/material';

import {Dispatch} from 'spectra-logic-ui';
import {FormDialog} from 'spectra-logic-ui/components';
import {patchCollection, patchResource} from 'spectra-logic-ui/actions';

import {Pod, Pool} from '@/types';

type Props = {
  pod?: Pod;
  pool?: Pool;
  disable: boolean;
  onSubmit: (values: any) => Promise<any>;
}

const DisableStorageDialog = ({pod, pool, disable, onSubmit, ...others}: Props) => {
  let title = (disable ? 'Disable' : 'Enable');
  const disableOrEnable = (disable ? 'disable' : 'enable');
  let description: string;
  if (pod) {
    title += ' Endpoint';
    description = `This will ${disableOrEnable} all storage on endpoint "${pod.name}" (${pod.id}). Are you sure you ` +
      'want to continue?';
  } else if (pool) {
    description = `This will ${disableOrEnable} storage "${pool.name}" (${pool.id}). Are you sure you want to ` +
      'continue?';
  }
  title += ' Storage';
  const submitLabel = (disable ? 'Disable' : 'Enable');

  return (
    <FormDialog title={title} submitLabel={submitLabel} onSubmit={onSubmit} {...others}>
      {() => (
        <Typography>{description}</Typography>
      )}
    </FormDialog>
  );
};

const mapDispatchToProps = (dispatch: Dispatch, {pod, pool, disable}: Props) => {
  const resource = 'storage';
  const ret: any = {};
  if (pool) {
    // Disable/enable a single storage pool;
    ret.onSubmit = () => dispatch(patchResource(resource, pool.id, {'disabled': disable}));
  } else {
    // Disable/enable all storage pools for the given endpoint;
    const body = {'status': disable ? 'disable' : 'enable'};
    const opts: any = {};
    if (pod) {
      opts.query = {endpoint: pod.id};
    }
    ret.onSubmit = () => dispatch(patchCollection(resource, body, opts));
  }
  return ret;
};

export default connect(undefined, mapDispatchToProps)(DisableStorageDialog);
